import { removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '../../settings/constants';
import { findDatasetMetrics } from './state';

const closeDatasetSettings = withDraft((draft, { category, code }) => {
  const item = findDatasetMetrics(draft, { category, code });
  if (item) {
    draft.datasetMetrics[category].results = (
      removeItemByCode(draft.datasetMetrics[category].results, item));
  }
});

export default {
  [actions.CLOSE_DATASET_SETTINGS]: closeDatasetSettings,
};
